import React from "react";
import { Container, Row, Col, Badge } from "reactstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { dataUrl, getContentByName, toArray } from "../../../helpers/common";
import parse from "html-react-parser";
import aboutUsStaticImg1 from "../../../assets/images/about/hospitality.jpg";
import aboutUsStaticImg from "../../../assets/images/about/img-01.jpg";
import aboutUsStaticImg2 from "../../../assets/images/about/aboutus2.jpg";
import aboutUsStaticImg3 from "../../../assets/images/about/aboutus3.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

// Inside your component function:

const About = () => {
  // 1. Redux se data nikalna
  const bannersState = useSelector((state) => state.banners["assets"]);
  const contentsState = useSelector(
    (state) => state.contents["partial_contents"],
  );

  // 2. CRITICAL FIX: Data ko Array format mein nikalna
  const assets = Array.isArray(bannersState)
    ? bannersState
    : bannersState?.data || [];
  const partialContents = Array.isArray(contentsState)
    ? contentsState
    : contentsState?.data || [];

  // 3. Data fetching using Helper functions
  const aboutusHeading = getContentByName(partialContents, "aboutus_heading");
  const aboutusDescription = getContentByName(
    partialContents,
    "aboutus_description",
  );
  const aboutusLeftPoints = getContentByName(
    partialContents,
    "aboutus_left_points",
  );
  const aboutusRightPoints = getContentByName(
    partialContents,
    "aboutus_right_points",
  );

  const aboutusLeftPointsArray = toArray(aboutusLeftPoints?.content, "\n");
  const aboutusRightPointsArray = toArray(aboutusRightPoints?.content, "\n");
  const sections = [
    {
      title: "Our Vision",
      icon: "uil-eye",
      text: "To become India's most trusted and preferred hospitality recruitment platform — empowering both job seekers and hotel owners to grow, thrive, and set new standards for Indian hospitality.",
      color: "#387ed8",
    },
    {
      title: "Our Mission",
      icon: "uil-rocket",
      text: "To bridge the gap between qualified hospitality talent and hotel employers who demand excellence — by delivering verified, trained, and service-ready professionals who elevate guest experiences and drive long-term business growth",
      color: "#2ecc71",
    },

    {
      title: "People First",
      icon: "uil-users-alt",
      text: "Every candidate is a career, not a commission. Every employer is a partner, not a transaction.",
      color: "#387ed8", // Webvi Blue
    },
    {
      title: "Integrity Always",
      icon: "uil-shield-check",
      text: "We are honest about expectations, timelines, and outcomes. Always and without compromise.",
      color: "#2ecc71", // Success Green
    },
    {
      title: "Excellence in Service",
      icon: "uil-star",
      text: "We hold ourselves to the same high standards we help our clients and candidates achieve.",
      color: "#f39c12", // Warning Orange
    },
    {
      title: "Continuous Growth",
      icon: "uil-chart-growth",
      text: "We evolve constantly — investing in better technology, deeper networks, and sharper hiring processes.",
      color: "#9b59b6", // Purple
    },
  ];
  const aboutusImg = assets.find((asset) => asset.name === "About Us Image");
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation speed in milliseconds
      once: true, // Whether animation should happen only once
    });
  }, []);
  // 4. UPDATED SAFETY CHECK: Ab ye sahi array check karega
  if (partialContents.length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <section
        className="section overflow-hidden py-5"
        style={{ background: "#fcfdfe" }}
      >
        <Container>
          {/* TOP ROW */}
          <Row className="align-items-center mb-5">
            {/* Image fades in from the left */}
            <Col lg={6} data-aos="fade-right">
              <div className="text-center position-relative">
                <img
                  src={aboutUsStaticImg}
                  alt="About Webvi"
                  className="img-fluid rounded-4 shadow-lg"
                  style={{
                    maxWidth: "100%",
                    height: "100%",
                    objectFit: "cover",
                    border: "8px solid #fff",
                  }}
                />
              </div>
            </Col>

            {/* Content fades in from the right */}
            <Col lg={6} data-aos="fade-left">
              <div className="section-title ms-lg-4 mt-4 mt-lg-0">
                <Badge
                  color="soft-primary"
                  className="mb-3 px-3 py-2 rounded-pill text-uppercase"
                >
                  About Our Vision
                </Badge>

                <h2 className="title mb-4 display-6 fw-bold">
                  {parse(
                    aboutusHeading?.content?.replace(/&nbsp;/gi, " ") ??
                      "Why so many People Trust On Webvi ?",
                  )}
                </h2>

                <div className="text-muted mb-4 fs-16">
                  {parse(
                    aboutusDescription?.content?.replace(/&nbsp;/gi, " ") ?? "",
                  )}
                </div>

                <div className="mt-4">
                  <Link
                    to="/page/about-us"
                    className="btn btn-primary btn-hover btn-lg px-4 shadow"
                  >
                    Our Story{" "}
                    <i className="uil uil-angle-right-b align-middle ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>

          {/* BOTTOM ROW: Points zoom in with a delay */}
          <div className="pt-5 border-top mt-5" data-aos="fade-up">
            <div className="mb-4 text-center text-lg-start">
              <h6
                className="text-primary text-uppercase fw-bold ls-1 mb-2"
                style={{ fontSize: "13px" }}
              >
                The Webvi Advantage
              </h6>
              <h3 className="fw-bold text-dark">Why You Choose Webvi</h3>
              <p className="text-muted">
                We deliver excellence through a dedicated focus on quality and
                reliability.
              </p>
            </div>

            <Row className="g-4">
              {[...aboutusLeftPointsArray, ...aboutusRightPointsArray].map(
                (point, index) => (
                  <Col
                    md={6}
                    lg={4}
                    key={index}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div className="d-flex align-items-center p-3 rounded-3 shadow-sm bg-white h-100 border-light hover-shadow">
                      <div className="flex-shrink-0">
                        <div
                          className="bg-soft-primary rounded-circle d-flex align-items-center justify-content-center"
                          style={{ width: "40px", height: "40px" }}
                        >
                          <i className="mdi mdi-check-circle-outline text-primary fs-22"></i>
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3 text-muted fw-medium">
                        {parse(point ?? "")}
                      </div>
                    </div>
                  </Col>
                ),
              )}
            </Row>
            <section className="section py-5">
              <Row
                className="align-items-center mb-100 py-5  rounded-5 p-2 p-md-4 "
                data-aos="fade-up"
              >
                <Col lg={12}>
                  <div className="text-center mb-4 mb-md-5">
                    <Badge
                      color="soft-warning"
                      className="mb-3 px-3 py-2 rounded-pill text-uppercase text-warning"
                    >
                      The Core Difference
                    </Badge>
                    <h3 className="fw-bold text-dark display-6 fs-24-mob">
                      How Webvi is different from other job portals
                    </h3>
                    <p
                      className="text-muted mx-auto px-2"
                      style={{ maxWidth: "700px", fontSize: "14px" }}
                    >
                      A clear side-by-side comparison of why top hospitality
                      brands and candidates choose Webvi over traditional
                      systems.
                    </p>
                  </div>
                </Col>

                <Col lg={12} className="px-md-4">
                  {/* Desktop & Tablet View (Hidden on Mobile) */}
                  <div className="d-none d-md-block table-responsive bg-white rounded-4 shadow-sm border overflow-hidden">
                    <table className="table table-hover align-middle mb-0">
                      <thead
                        className="bg-dark text-white text-uppercase fs-13"
                        style={{ letterSpacing: "1px" }}
                      >
                        <tr>
                          <th
                            className="py-4 ps-4"
                            style={{
                              width: "30%",
                              backgroundColor: "#f7941f",
                              color: "#fff",
                            }}
                          >
                            Features
                          </th>
                          <th
                            className="py-4 text-center opacity-75"
                            style={{
                              width: "35%",
                              backgroundColor: "#f8f9fa",
                              color: "#6c757d",
                            }}
                          >
                            Other Job Portals
                          </th>
                          <th
                            className="py-4 text-center fw-bold"
                            style={{
                              width: "35%",
                              backgroundColor: "#387ed8",
                              color: "#fff",
                            }}
                          >
                            <i className="uil uil-star me-1 text-white animate-bounce"></i>{" "}
                            Webvi Advantage
                          </th>
                        </tr>
                      </thead>
                      <tbody className="fs-15">
                        <tr>
                          <td className="py-4 ps-4 fw-bold text-dark">
                            <i className="uil uil-shield-check text-primary me-2 fs-18"></i>{" "}
                            Talent Sourcing
                          </td>
                          <td className="py-4 text-center text-muted">
                            <i className="uil uil-times-circle text-danger me-1"></i>{" "}
                            Unverified bulk resumes & unvetted profiles
                          </td>
                          <td
                            className="py-4 text-center fw-medium"
                            style={{
                              backgroundColor: "rgba(56, 126, 216, 0.03)",
                            }}
                          >
                            <i className="uil uil-check-circle text-success me-1 fs-18"></i>{" "}
                            Strictly screened & shortlisted profiles
                          </td>
                        </tr>
                        <tr>
                          <td className="py-4 ps-4 fw-bold text-dark">
                            <i className="uil uil-comment-alt-block text-danger me-2 fs-18"></i>{" "}
                            Application Updates
                          </td>
                          <td className="py-4 text-center text-muted">
                            <i className="uil uil-times-circle text-danger me-1"></i>{" "}
                            Silent rejections & absolute applicant ghosting
                          </td>
                          <td
                            className="py-4 text-center fw-medium"
                            style={{
                              backgroundColor: "rgba(56, 126, 216, 0.03)",
                            }}
                          >
                            <i className="uil uil-check-circle text-success me-1 fs-18"></i>{" "}
                            Transparent & mandatory reason for rejection
                          </td>
                        </tr>
                        <tr>
                          <td className="py-4 ps-4 fw-bold text-dark">
                            <i className="uil uil-sliders-v-alt text-success me-2 fs-18"></i>{" "}
                            Search Filters
                          </td>
                          <td className="py-4 text-center text-muted">
                            <i className="uil uil-times-circle text-danger me-1"></i>{" "}
                            Basic single-selection filters that reset often
                          </td>
                          <td
                            className="py-4 text-center fw-medium"
                            style={{
                              backgroundColor: "rgba(56, 126, 216, 0.03)",
                            }}
                          >
                            <i className="uil uil-check-circle text-success me-1 fs-18"></i>{" "}
                            Advanced multi-select & gender-based filters
                          </td>
                        </tr>
                        <tr></tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Pure Responsive Cards View (Hidden on Desktop/Tablet) */}
                  <div className="d-block d-md-none d-flex flex-column gap-3 px-2">
                    {[
                      {
                        title: "Talent Sourcing",
                        icon: "uil-shield-check text-primary",
                        other: "Unverified bulk resumes & unvetted profiles",
                        webvi: "Strictly screened & shortlisted profiles",
                      },
                      {
                        title: "Application Updates",
                        icon: "uil-comment-alt-block text-danger",
                        other:
                          "Silent rejections & absolute applicant ghosting",
                        webvi: "Transparent & mandatory reason for rejection",
                      },
                      {
                        title: "Search Filters",
                        icon: "uil-sliders-v-alt text-success",
                        other:
                          "Basic single-selection filters that reset often",
                        webvi: "Advanced multi-select & gender-based filters",
                      },
                    ].map((item, idx) => (
                      <div
                        key={idx}
                        className="bg-white rounded-4 shadow-sm border p-3"
                      >
                        {/* Feature Header */}
                        <div className="d-flex align-items-center mb-3 border-bottom pb-2">
                          <i className={`uil ${item.icon} fs-20 me-2`}></i>
                          <h6 className="fw-bold text-dark mb-0 fs-15">
                            {item.title}
                          </h6>
                        </div>
                        {/* Others */}
                        <div
                          className="p-2 rounded-3 mb-2"
                          style={{ backgroundColor: "#fff5f5" }}
                        >
                          <span
                            className="text-muted d-block uppercase-heading"
                            style={{ fontSize: "10px", fontWeight: "700" }}
                          >
                            OTHER PORTALS
                          </span>
                          <p className="text-danger mb-0 fs-13 fw-medium">
                            <i className="uil uil-times-circle me-1"></i>{" "}
                            {item.other}
                          </p>
                        </div>
                        {/* Webvi Advantage */}
                        <div
                          className="p-2 rounded-3 border border-primary-subtle"
                          style={{
                            backgroundColor: "rgba(56, 126, 216, 0.05)",
                          }}
                        >
                          <span
                            className="text-primary d-block uppercase-heading"
                            style={{ fontSize: "10px", fontWeight: "700" }}
                          >
                            WEBVI ADVANTAGE
                          </span>
                          <p className="text-success mb-0 fs-13 fw-semibold">
                            <i className="uil uil-check-circle me-1"></i>{" "}
                            {item.webvi}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>

                {/* Extra Responsive Styling Patch */}
                <style
                  dangerouslySetInnerHTML={{
                    __html: `
                     @media (max-width: 576px) {
                      .fs-24-mob { font-size: 20px !important; }
                      .uppercase-heading { letter-spacing: 0.5px; }
                     }
                     `,
                  }}
                />
              </Row>
              <Container>
                {/* Section Header */}
                <div className="text-center mb-5" data-aos="fade-up">
                  <h2 className="display-5 fw-bold text-dark">
                    Our Hospitality Journey
                  </h2>
                  <p
                    className="text-muted mx-auto"
                    style={{ maxWidth: "600px" }}
                  >
                    From humble beginnings to industry leaders, here is how
                    Webvi redefined excellence.
                  </p>
                </div>

                {/* Block 1: Text Left, Image Right */}
                <Row className="align-items-center mb-100 py-4">
                  <Col lg={6} data-aos="fade-right">
                    <div className="pe-lg-5">
                      <h6 className="text-primary fw-bold mb-3">
                        Elevating Standards: Since 2024
                      </h6>
                      <h3 className="mb-4 fw-bold">
                        Deep Roots in Hospitality
                      </h3>
                      <p
                        className="text-muted fs-16 mb-4"
                        style={{ lineHeight: "1.8" }}
                      >
                        Webvi started with a single mission: to bridge the gap
                        between elite talent and luxury brands. Our deep
                        hospitality roots allow us to speak the language of
                        service, ensuring that every placement we make is driven
                        by core principles of integrity and excellence.
                      </p>
                      <p className="text-muted fs-16">
                        We don't just find employees; we find the future faces
                        of your hotel lobby, your high-end restaurant, and your
                        luxury clinical care teams.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} data-aos="fade-left">
                    <img
                      src={aboutUsStaticImg1}
                      alt="Journey"
                      className="img-fluid rounded-5 shadow-lg"
                    />
                  </Col>
                </Row>

                {/* Block 2: Image Left, Text Right (The Switch) */}
                <Row className="align-items-center mb-100 py-5">
                  <Col
                    lg={6}
                    className="order-2 order-lg-1"
                    data-aos="fade-right"
                  >
                    <img
                      src={aboutUsStaticImg2}
                      alt="Innovation"
                      className="img-fluid rounded-5 shadow-lg"
                    />
                  </Col>
                  <Col
                    lg={6}
                    className="order-1 order-lg-2"
                    data-aos="fade-left"
                  >
                    <div className="ps-lg-5">
                      <h6 className="text-info fw-bold mb-3">
                        Community & Innovation
                      </h6>
                      <h3 className="mb-4 fw-bold">
                        Technological Integration
                      </h3>
                      <p
                        className="text-muted fs-16 mb-4"
                        style={{ lineHeight: "1.8" }}
                      >
                        In 2026, hospitality is as much about technology as it
                        is about people. Webvi utilizes proprietary AI-driven
                        matching to ensure candidates aren't just qualified on
                        paper, but culturally aligned with your brand's specific
                        hospitality DNA.
                      </p>
                      <div className="d-flex gap-3">
                        <div className="text-center">
                          <h4 className="fw-bold text-primary mb-0">50+</h4>
                          <small className="text-muted">Partners</small>
                        </div>
                        <div className="border-start ps-3 text-center">
                          <h4 className="fw-bold text-primary mb-0">2k</h4>
                          <small className="text-muted">Placements</small>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Block 3: Text Left, Image Right */}
                <Row className="align-items-center py-4">
                  <Col lg={6} data-aos="fade-right">
                    <div className="pe-lg-5">
                      <h6 className="text-success fw-bold mb-3">
                        Empowering Your Growth
                      </h6>
                      <h3 className="mb-4 fw-bold">A Personalized Approach</h3>
                      <p
                        className="text-muted fs-16 mb-4"
                        style={{ lineHeight: "1.8" }}
                      >
                        We believe that when a hospitality professional thrives,
                        the entire brand elevates. Our focus is on enabling
                        growth for both the candidate and the employer, creating
                        a thriving ecosystem of professional hospitality
                        service.
                      </p>
                      {/* <Button color="primary" outline className="rounded-pill px-4">Download Our Brochure</Button> */}
                    </div>
                  </Col>
                  <Col lg={6} data-aos="fade-left">
                    <img
                      src={aboutUsStaticImg3}
                      alt="Growth"
                      className="img-fluid rounded-5 shadow-lg"
                    />
                  </Col>
                </Row>
              </Container>
              <section className="py-5">
                <Container>
                  <div className="text-center mb-5">
                    <h6
                      className="text-uppercase fw-bold text-primary mb-2"
                      style={{ letterSpacing: "2px" }}
                    >
                      Webvi Goals
                    </h6>
                    <h2 className="fw-bold text-dark">Why We Exist</h2>
                    <div
                      className="mx-auto"
                      style={{
                        height: "3px",
                        width: "60px",
                        backgroundColor: "#387ed8",
                      }}
                    ></div>
                  </div>

                  <Row className="g-4">
                    {sections.map((item, index) => (
                      <Col lg={4} md={6} key={index}>
                        <Card
                          className="h-100 border-0 shadow-sm text-center p-4"
                          style={{
                            borderRadius: "20px",
                            transition: "transform 0.3s ease",
                          }}
                        >
                          <div
                            className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                              width: "70px",
                              height: "70px",
                              backgroundColor: `${item.color}15`,
                              color: item.color,
                            }}
                          >
                            <i
                              className={`uil ${item.icon}`}
                              style={{ fontSize: "32px" }}
                            ></i>
                          </div>
                          <Card.Body className="p-0">
                            <h4 className="fw-bold mb-3">{item.title}</h4>
                            <p className="text-muted lh-base">{item.text}</p>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </Container>

                <style
                  dangerouslySetInnerHTML={{
                    __html: `
        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
        }
      `,
                  }}
                />
              </section>
            </section>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default About;
